import { DEFAULT_MESSAGE_TTL, SHORT_TIME_INTERVAL } from "./constants";
import Metric from "./models/Metric";
import TelemetryClientData from "./models/TelemetryClientData";
import TelemetryClient from "./TelemetryClient";
import TelemetryProcessor from "./TelemetryProcessor";

export default class MetricsClient {
  private static telemetryProcessor: TelemetryProcessor<Metric>;
  private static readonly APIEndpoint: string = "/v1/metrics";

  private constructor() {}

  /**
   * Function to get an instance of TelemetryProcessor
   */
  private static processor(): TelemetryProcessor<Metric> {
    if (!MetricsClient.telemetryProcessor) {
      if (!TelemetryClient.isInitialized) {
        throw new Error("Initialize TelemetryClient before using the logger");
      }
      MetricsClient.telemetryProcessor = new TelemetryProcessor<Metric>(
        "metrics",
        SHORT_TIME_INTERVAL,
        this.metricProcessor.bind(this),
        this.APIEndpoint,
      );
    }
    return MetricsClient.telemetryProcessor;
  }

  /**
   * Function to get an instance of MetricsClient
   */
  public static getMetricsClient() {
    return new MetricsClient();
  }

  /**
   * Function to get an validate sendMetric arguments
   */
  private validateDimensionParamaters(dimensions?: Record<string, string>) {
    if (dimensions && Object.keys(dimensions).length != 0) {
      Object.keys(dimensions).forEach((key: string) => {
        const value: string = dimensions[key];
        if (!key || !value || typeof key !== "string" || typeof value !== "string") {
          throw new Error("Dimension key and value must be a non empty string");
        }
      });
    }
  }

  /**
   * Function used by the user to send a metric
   * @param name
   * @param value
   */
  public sendMetric(name: string, value: number, dimensions?: Record<string, string>) {
    this.validateDimensionParamaters(dimensions);
    const metric: Metric = {
      name,
      value,
      dimensions,
      timestamp: Date.now(),
    };
    if (!TelemetryClient.config || !TelemetryClient.config.postToTelemetryService) {
      console.debug(`metrics - ${name}:`, metric);
      return;
    }
    const data: TelemetryClientData<Metric> = {
      TTL: new Date().getTime() + DEFAULT_MESSAGE_TTL,
      payload: metric,
    };
    MetricsClient.processor().add(data);
  }

  /**
   * We don't need to add any information post authentication, hence just return. Might need it in future
   * @param metric
   */
  private static metricProcessor(metric: Metric) {
    return metric;
  }
}
